<template>
  <CustomerDetailPlaceholderTab title="Facturas" />
</template>

<script>
import CustomerDetailPlaceholderTab from './CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailInvoicesTab',
  components: { CustomerDetailPlaceholderTab },
};
</script>
